// extracted by mini-css-extract-plugin
export default {"table_root":"tableStructure_table_root__E+PHV"};